import { BenefitCardsBlock } from 'cms-types'
import { type LoadableComponentProps, type LocalizedComponentProps } from 'ui'

import { BenefitCardsClient } from './BenefitCardsClient'

function BenefitCards({
  data,
  loading,
}: LocalizedComponentProps<LoadableComponentProps<BenefitCardsBlock>>) {
  if (loading) return <BenefitCardsClient loading />

  return <BenefitCardsClient data={data} />
}

export default BenefitCards
BenefitCards.loadable = true
